import { usePostTablesSettingsAdministrationLicenseConsumptionOverview } from '@ipfabric/api-client/client/model/license/license';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { useTableQueryWithMandatoryColumns } from 'utils/table/useTableQueryWithMandatoryColumns';

const OVERVIEW_COLUMNS = [
  'category',
  'type',
  'tier',
  'count',
  'proportion',
] as const;

/** `tier` stays optional - it is legitimately NULL for on-premise devices. */
const MANDATORY_COLUMNS = ['category', 'type', 'count', 'proportion'] as const;

/**
 * Both breakdowns of the License overview page come from this one request: the endpoint returns
 * every category, and splitting them client-side keeps the two halves of the card in one loading
 * state.
 *
 * No `pagination` on purpose - the table defaults to no limit, so the full breakdown comes back.
 * Sending a page size would silently truncate the charts.
 */
export const useLicenseConsumptionOverview = () => {
  const snapshotId = useSnapshotId();
  const queryResult =
    usePostTablesSettingsAdministrationLicenseConsumptionOverview(
      {
        columns: [...OVERVIEW_COLUMNS],
        snapshot: snapshotId ?? '$last',
      },
      { query: { enabled: snapshotId !== null } },
    );

  return useTableQueryWithMandatoryColumns([...MANDATORY_COLUMNS], queryResult);
};
